var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmbrellaRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24737 19H2.47619C2.2132 19 2 18.7868 2 18.5238C2 13.7481 5.51506 9.79345 10.0991 9.10583C9.90136 9.30494 9.72404 9.52725 9.56608 9.75984C9.00681 10.5833 8.5921 11.6688 8.27858 12.7795C7.64858 15.0115 7.36727 17.5694 7.25262 18.9374L7.24737 19Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75269 19C8.8684 17.6444 9.14127 15.2451 9.72218 13.187C10.0186 12.1367 10.3805 11.2305 10.807 10.6026C11.2367 9.96978 11.636 9.75 12 9.75C12.364 9.75 12.7633 9.96978 13.193 10.6026C13.6195 11.2305 13.9814 12.1367 14.2778 13.187C14.8587 15.2451 15.1316 17.6444 15.2473 19H8.75269Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4339 9.75984C14.276 9.52725 14.0986 9.30494 13.9009 9.10583C18.4849 9.79345 22 13.7481 22 18.5238C22 18.7868 21.7868 19 21.5238 19H16.7526L16.7474 18.9374C16.6327 17.5694 16.3514 15.0115 15.7214 12.7795C15.4079 11.6688 14.9932 10.5833 14.4339 9.75984Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19V24H12.75V19H11.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50236 5.09067C4.94688 5.30236 5.12706 5.81717 4.9048 6.24054L3.70496 8.52604C3.4827 8.94941 2.94216 9.12102 2.49764 8.90933C2.05312 8.69764 1.87294 8.18283 2.0952 7.75946L3.29504 5.47396C3.5173 5.05059 4.05784 4.87899 4.50236 5.09067Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5024 2.09067C15.9469 2.30236 16.1271 2.81717 15.9048 3.24054L14.705 5.52604C14.4827 5.94941 13.9422 6.12102 13.4976 5.90933C13.0531 5.69764 12.8729 5.18283 13.0952 4.75946L14.295 2.47396C14.5173 2.05059 15.0578 1.87899 15.5024 2.09067Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5024 4.09067C21.9469 4.30236 22.1271 4.81717 21.9048 5.24054L20.705 7.52604C20.4827 7.94941 19.9422 8.12102 19.4976 7.90933C19.0531 7.69764 18.8729 7.18283 19.0952 6.75946L20.295 4.47396C20.5173 4.05059 21.0578 3.87899 21.5024 4.09067Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50236 2.09067C9.94688 2.30236 10.1271 2.81717 9.9048 3.24054L8.70496 5.52604C8.4827 5.94941 7.94216 6.12102 7.49764 5.90933C7.05312 5.69764 6.87294 5.18283 7.0952 4.75946L8.29504 2.47396C8.5173 2.05059 9.05784 1.87899 9.50236 2.09067Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrellaRain);
export default __webpack_public_path__ + "static/media/umbrella-rain.51e3cae6759435fb3bb19247cac8fdb9.svg";
export { ForwardRef as ReactComponent };